import { pricingRulesetType } from "@redotech/redo-conversion-core-common/conversion/treatment";
import type { PricingRuleSet } from "@redotech/redo-return-coverage-common/coverage-types";
import * as z from "zod";

/** What an unconfigured team charges: 2% of the cart, every order. */
export const DEFAULT_PRICING_PERCENTAGE = 0.02;

export const PriceBracketSchema = z.object({
  value: z.number(),
  pricePoint: z.number(),
});

export const PricingRuleSetSchema = z.object({
  type: z.enum(pricingRulesetType),
  countries: z.array(z.string()),
  priceBrackets: z.array(PriceBracketSchema),
});

/**
 * Reads never have to cope with an empty set: a team that has not configured
 * pricing gets the single percentage bracket it is already being charged at.
 */
export function pricingRuleSetsFromSettings({
  pricingRuleSet,
  percentage,
  countries,
}: {
  pricingRuleSet: PricingRuleSet[] | null | undefined;
  percentage: number | null | undefined;
  countries: string[];
}): PricingRuleSet[] {
  if (pricingRuleSet?.length) {
    return pricingRuleSet;
  }
  return [
    {
      type: "percentage",
      countries,
      priceBrackets: [
        { value: percentage ?? DEFAULT_PRICING_PERCENTAGE, pricePoint: 0 },
      ],
    },
  ];
}
